import { BehaviorSubject } from 'rxjs';
import { Injectable, TemplateRef } from '@angular/core';

@Injectable()
export class PageTitleBarService {
  private readonly subject = new BehaviorSubject<TemplateRef<unknown> | null>(null);
  public readonly template$ = this.subject.asObservable();

  public show(template: TemplateRef<unknown>): void {
    this.subject.next(template);
  }

  public destroy(): void {
    this.subject.next(null);
  }
}
